import { StorefrontModule } from "@lib/appRegister";
import { AppointmentStore } from "./store";

export const AppointmentModule: StorefrontModule = function ({ store }) {
  store.registerModule("appointment", AppointmentStore);
  store.dispatch("appointment/init");
};
